var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('default-count-card',{staticStyle:{"height":"100%"},attrs:{"value":_vm.data,"title":_vm.title,"icon":_vm.icon,"title_class":_vm.title_class,"icon_color":_vm.icon_color},scopedSlots:_vm._u([{key:"extra",fn:function(){return undefined},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }